import type { ReactNode } from 'react';

import { Label as LabelPrimitive } from '@connected/ui/components/label';
import { cn } from '@connected/ui/lib/utils';

export type LabelProps = {
    children: ReactNode;
    label?: ReactNode;
    className?: string;
    slot?: ReactNode;
    htmlFor?: string;
};

/**
 * @deprecated Use the Label component from @connected/ui/components/label or field.label instead
 */
export function Label({
    label,
    children,
    htmlFor,
    className,
    slot,
}: LabelProps) {
    if (htmlFor !== undefined) {
        return (
            <div className="flex flex-col gap-1">
                <LabelPrimitive htmlFor={htmlFor}>
                    {label && (
                        <div className="flex justify-between">
                            <span>{label}</span>
                            {slot}
                        </div>
                    )}
                </LabelPrimitive>
                {children}
            </div>
        );
    }

    return (
        <LabelPrimitive className={cn('flex flex-col gap-1', className)}>
            <>
                {label && (
                    <div className="flex justify-between">
                        <span>{label}</span>
                        {slot}
                    </div>
                )}
                {children}
            </>
        </LabelPrimitive>
    );
}
